<template lang="pug">
chart(:option="option"
    style="max-height: 400px;height:70vh")
</template>

<script>
import Chart from '../../components/Chart.vue';

export default {
    props: ['pnlData'],
    components: {
        Chart,
    },
    computed: {
        option() {
            return {
                legend: {},
                dataZoom: [{
                    type: 'inside',
                    zoomOnMouseWheel: true,
                    moveOnMouseMove: true,
                    moveOnMouseWheel: false,
                }],
                dataset: {
                    dimensions: ['date', 'otc_total_pnl', 't0_total_pnl', 'total_pnl'],
                    source: this.pnlData,
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                xAxis: {
                    type: 'category'
                },
                yAxis: {
                    type: 'value',
                    scale: true,
                },
                series: [
                    {
                        type: 'line',
                        showSymbol: false,
                        name: 'OTC Total Pnl',
                    },
                    {
                        type: 'line',
                        showSymbol: false,
                        name: 'LongShort Total Pnl',
                    },
                    {
                        type: 'line',
                        showSymbol: false,
                        name: 'Total Pnl',
                    }
                ],
            }
        }
    }
}
</script>

<style lang="less" scoped>
.chart {
    height: 300px;
    min-width: 300px;
    // margin: 5px;
}
</style>